import React from 'react'

import { oneOf, string, node } from 'prop-types'

import * as S from './styled'

const Section = ({ children, ...rest }) => (
  <S.SectionWrapper {...rest}>{children}</S.SectionWrapper>
)

Section.propTypes = {
  children: node,
  bg: string,
  bgImage: string,
  texture: oneOf(['light', 'dark']),
}

export default Section
